<template>
    <v-layout class="audio-controls">
        <button aria-label="Reproducir audio" class="hvr-grow" @click="playAudio(currentId)">
            <v-icon>fa fa-play-circle</v-icon>            
        </button>
        <button aria-label="Pausar audio" class="hvr-grow" @click="pauseAudio()">
            <v-icon>fa fa-pause-circle</v-icon>            
        </button>
    </v-layout>
</template>
<script>
 export default {
   props: {
     audios: {
       type: Array,
       required: true
     },
     autoplay:{
         type: Boolean,
         required: false,
         default: false
     }
   },
    data() {
        return {
            loadedAudios: [],
            audio: {},
            currentId: 0,
            currentTime: 0,
        }
    },
   methods: {
    loadAudio(){
        for (var i = 0; i < this.audios.length ; i++){
            this.loadedAudios.push(this.audios[i])
        }
        console.log(this.loadedAudios);
    },
    playAudio(id){
        if(typeof this.audio.paused != "undefined"){
            if (!this.audio.paused) this.audio.pause();
        }
        if(id > this.loadedAudios.length-1){
            console.error("No audio for "+id);
            return;
        }
        try{
            this.currentId = id;
            var path = require('../../assets/audios/'+this.loadedAudios[id]); //Reproduce el audio según el texto que se muestre
            this.audio = new Audio(path);
            this.audio.currentTime = this.currentTime;
            this.audio.play();
            this.audio.onended = ()=>{
                this.currentTime = 0;
            };
        }catch(err){
            console.error(err);
        }
    },
    autoPlay(){
        if(this.autoplay) this.playAudio(0);
    },
    pauseAudio(){
        if (!this.audio.paused) {
            this.currentTime = this.audio.currentTime;
            this.audio.pause();
        }
    }
  },
    mounted(){
    this.loadAudio(); //Carga las rutas
    this.autoPlay();
    },
    beforeDestroy(){
        if(typeof this.audio !== "undefined")
            this.audio.pause(); //Previene que el audio se propage en otras pantallas
    },
 }
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/variables.scss';
.theme--light{
    .audio-controls{
        .icon{
            font-size: 40px;
            color:$primary-red;
            padding: 0 5px;            
        }
    }
}

.dark{
    .audio-controls{
        .icon{
            font-size: 40px;
            color:$secondary-red;
            padding: 0 5px;            
        }
    }
}
@media(min-width: 1200px){
    .audio-controls{
        .icon{
            font-size: 40px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// AudioPlayer.vue?0970851f